export const currencyCode = {
  // Fiat Currencies
  'AED': 'د.إ',
  'AMD': '֏',
  'ARS': '$',
  'AUD': '$',
  'AZN': '₼',
  'BDT': '৳',
  'BGN': 'лв',
  'BRL': 'R$',
  'CAD': '$',
  'CHF': 'CHF',
  'CLP': '$',
  'CNY': '¥',
  'COP': '$',
  'CZK': 'Kč',
  'DKK': 'kr',
  'EGP': '£',
  'EUR': '€',
  'GBP': '£',
  'GEL': '₾',
  'HKD': '$',
  'HUF': 'Ft',
  'IDR': 'Rp',
  'ILS': '₪',
  'INR': '₹',
  'ISK': 'kr',
  'JPY': '¥',
  'KES': 'KSh',
  'KGS': 'сом',
  'KRW': '₩',
  'KZT': '₸',
  'LKR': '₨',
  'MAD': 'د.م.',
  'MXN': '$',
  'MYR': 'RM',
  'NGN': '₦',
  'NOK': 'kr',
  'NZD': '$',
  'PEN': 'S/',
  'PHP': '₱',
  'PKR': '₨',
  'PLN': 'zł',
  'QAR': '﷼',
  'RON': 'lei',
  'RSD': 'Дин.',
  'RUB': '₽',
  'SAR': '﷼',
  'SEK': 'kr',
  'SGD': '$',
  'THB': '฿',
  'TRY': '₺',
  'TWD': 'NT$',
  'TZS': 'TSh',
  'UAH': '₴',
  'USD': '$',
  'UYU': '$U',
  'UZS': 'soʻm',
  'VND': '₫',
  'ZAR': 'R',

  // Crypto Currencies
  'BTC': 'BTC',
  'ETH': 'ETH',
  'USDT': 'USDT',
  'USDC': 'USDC',
  'BNB': 'BNB',
  'SOL': 'SOL',
  'TRX': 'TRX',
  'XRP': 'XRP',
  'LTC': 'LTC',
  'DOGE': 'DOGE',
  'ADA': 'ADA',
  'TON': 'TON',
  'MATIC': 'MATIC',
  'AVAX': 'AVAX',
  'BCH': 'BCH',
  'XLM': 'XLM',
  'SUI': 'SUI',
};


export const TRANSLATIONS = {
  EN: 'EN',
  TR: 'TR',
  RO: 'RO'
}

  export const errorMessageCode = {
    'UNFINISHED_SLOT_GAME_BET_EXISTS': 'SESSION EXPIRED',
    'RGS_UNREACHABLE': 'RGS UNREACHABLE',
    'ERR_NETWORK': 'INTERNET DISCONNECTED',
    'ERR_BAD_REQUEST': 'BAD REQUEST',
    'BASE_SLOT_GAME_BET_NOT_EXISTS': 'BET DOES NOT EXIST',
    'CONNECTION_LOST': 'CONNECTION LOST',
    'INSUFFICIENT_FUNDS': 'INSUFFICIENT FUNDS',
    'INVALID_TOKEN': 'INVALID TOKEN',
    'UNKNOWN_OPERATOR_ERROR': 'UNKNOWN OPERATOR ERROR'
  }